import { render, staticRenderFns } from "./AddDisplayComponent.vue?vue&type=template&id=6334980f&"
import script from "./AddDisplayComponent.vue?vue&type=script&lang=js&"
export * from "./AddDisplayComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports